import SvgIcon from "@mui/material/SvgIcon";

const NotAuthorizedIcon = ({ fill = "#231F20", color = "#fff", ...props }) => {
    return (
        <SvgIcon
            viewBox="0 0 265 271"
            {...props}
            style={{
                width: props.width || "100%",
                height: props.height || "auto",
                ...props.style,
            }}
        >
            <path
                fill="url(#a)"
                d="M50 5a5 5 0 0 1 5-5h105.403a5 5 0 0 1 3.567 1.496l52.597 53.545A5.002 5.002 0 0 1 218 58.545V212a5 5 0 0 1-5 5H55a5 5 0 0 1-5-5V5Z"
            />
            <rect
                width="131"
                height="10"
                x="68"
                y="166"
                fill="#F8F8F8"
                rx="5"
            />
            <rect
                width="131"
                height="10"
                x="68"
                y="135"
                fill="#F8F8F8"
                rx="5"
            />
            <rect
                width="131"
                height="10"
                x="68"
                y="104"
                fill="#F8F8F8"
                rx="5"
            />
            <rect width="131" height="10" x="68" y="73" fill="#F8F8F8" rx="5" />
            <rect width="117" height="10" x="68" y="42" fill="#F8F8F8" rx="5" />
            <path fill="#37474F" d="m162 0 56 57h-51a5 5 0 0 1-5-5V0Z" />
            <g filter="url(#b)">
                <path
                    fill="#F8F8F8"
                    d="M180 129a6 6 0 0 1 6-6h63a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-63a6 6 0 0 1-6-6v-52Z"
                />
            </g>
            <path
                fill="#C7C7C7"
                d="M232 109.274C232 101.446 225.563 95 217.5 95c-8.063 0-14.5 6.446-14.5 14.274V123h-10v-13.726C193 95.814 204.024 85 217.5 85S242 95.813 242 109.274V123h-10v-13.726Z"
            />
            <g filter="url(#c)">
                <path
                    fill="#F8F8F8"
                    d="m16 186.091 5.354-1.825a136.525 136.525 0 0 0 24.434-11.114L49.5 171l3.712 2.152a136.525 136.525 0 0 0 24.434 11.114L83 186.091v8.566a82.205 82.205 0 0 1-7.123 33.475 40.968 40.968 0 0 1-13.447 16.544L49.5 254l-12.93-9.324a40.968 40.968 0 0 1-13.447-16.544A82.205 82.205 0 0 1 16 194.657v-8.566Z"
                />
            </g>
            <path
                fill="url(#d)"
                d="M44 214.833 52.308 195v14H56l-7.385 21v-15.167H44Z"
            />
            <path
                fill="#37474F"
                d="M44 214.833 52.308 195v14H56l-7.385 21v-15.167H44ZM218 135c6.627 0 12 5.373 12 12 0 4.441-2.414 8.316-6 10.391V169a6 6 0 1 1-12 0v-11.609c-3.586-2.075-6-5.95-6-10.391 0-6.627 5.373-12 12-12Z"
            />
            <defs>
                <filter
                    id="b"
                    width="95"
                    height="84"
                    x="170"
                    y="114"
                    color-interpolation-filters="sRGB"
                    filterUnits="userSpaceOnUse"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        result="hardAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="5" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_496_1889"
                    />
                    <feBlend
                        in="SourceGraphic"
                        in2="effect1_dropShadow_496_1889"
                        result="shape"
                    />
                </filter>
                <filter
                    id="c"
                    width="99"
                    height="115"
                    x="0"
                    y="156"
                    color-interpolation-filters="sRGB"
                    filterUnits="userSpaceOnUse"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        result="hardAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="8" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_496_1889"
                    />
                    <feBlend
                        in="SourceGraphic"
                        in2="effect1_dropShadow_496_1889"
                        result="shape"
                    />
                </filter>
                <linearGradient
                    id="a"
                    x1="25"
                    x2="342.5"
                    y1="-37.5"
                    y2="348"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#fff" />
                    <stop offset="1" stop-color="#37474F" />
                </linearGradient>
            </defs>
        </SvgIcon>
    );
};

export default NotAuthorizedIcon;
